"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const immutable_1 = require("immutable");
const utils_1 = require("../utils");
const types = require("./types");
const errorMessage = utils_1.createReducer(immutable_1.Map())({
    [types.UPDATE_FAILURE]: (s, action) => s.set(action.extensionName, action.errorMessage),
    [types.UPDATE_REQUEST]: (s, action) => s.set(action.extensionName, null),
    [types.UPDATE_SUCCESS]: (s, action) => s.set(action.extensionName, null),
});
const isProcessing = utils_1.createReducer(immutable_1.Map())({
    [types.UPDATE_FAILURE]: (s, action) => s.set(action.extensionName, false),
    [types.UPDATE_REQUEST]: (s, action) => s.set(action.extensionName, true),
    [types.UPDATE_SUCCESS]: (s, action) => s.set(action.extensionName, false),
});
const state = utils_1.createReducer(immutable_1.Map())({
    [types.UPDATE_SUCCESS]: (s, action) => {
        return s.set(action.extensionName, action.data);
    },
});
// tslint:disable-next-line: no-default-export
exports.default = redux_1.combineReducers({
    errorMessage, isProcessing, state,
});
//# sourceMappingURL=reducers.js.map